module.exports = __webpack_public_path__ + "img/light_turner.97e8fc6e.png";